import { render, staticRenderFns } from "./QuotaName.vue?vue&type=template&id=0f4ab45f&"
import script from "./QuotaName.vue?vue&type=script&lang=js&"
export * from "./QuotaName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4ab45f')) {
      api.createRecord('0f4ab45f', component.options)
    } else {
      api.reload('0f4ab45f', component.options)
    }
    module.hot.accept("./QuotaName.vue?vue&type=template&id=0f4ab45f&", function () {
      api.rerender('0f4ab45f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/components/QuotaName.vue"
export default component.exports